export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Martes_scroll.79939b15.png";